export const modulePermissionMap = {
  dashboard: 'dashboard',
  crm: 'crm',
  cms: 'cms',
  marketing: 'marketing',
  operations: 'operations',
  reports: 'reports',
  hr: 'hr',
  finance: 'finance',
  calendar: 'calendar',
  administration: 'administration',
};

export const buildVisibleAgencyModules = ({ agencyModules, canView }) => agencyModules.reduce((acc, module) => {
  if (module.hidden) return acc;

  const hasAnyPermission = (perms = []) => perms.some((perm) => canView(perm));
  const permKey = modulePermissionMap[module.id];
  const parentGranted = module.id === 'dashboard'
    ? true
    : module.visibilityPermissionsAny
      ? hasAnyPermission(module.visibilityPermissionsAny)
      : (!permKey || canView(permKey));

  if (module.submodules?.length) {
    const filteredSubs = module.submodules.filter((submodule) =>
      !submodule.hidden
      && (submodule.permissionsAny
        ? hasAnyPermission(submodule.permissionsAny)
        : (submodule.permission ? canView(submodule.permission) : parentGranted))
    );

    if (!parentGranted && filteredSubs.length === 0) return acc;
    acc.push({ ...module, submodules: filteredSubs });
    return acc;
  }

  if (!parentGranted) return acc;
  acc.push(module);
  return acc;
}, []);